import { Store } from '@ngrx/store';
// Utils
import { getSharingButtonConfig } from 'SharingApp/ts/utils/public-sharing-utils';
// Types / Enums
import { ChartDropdownOption } from 'ChartApp/ts/enums/chart-common.enum';
import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
// Components / Directives
import { FolderableBase } from 'FoldersApp/directives/folderable-base.directive';
import { OpenItemPreviewModalComponent } from 'NewAngular/features/components/saved-items/open-item-modal/components/open-item-preview-modal/open-item-preview-modal.component';
// Services
import { FolderableAjaxService } from 'FoldersApp/services/folderable-ajax.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import { ToastMessagesService } from 'NewAngular/features/components/toast-messages/toast-messages.service';
// NgRx
import { setSelectedFolderableOperation } from 'FoldersApp/state/selected-folder-item/selected-folderable-operation.action';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/folderable-ajax.service";
import * as i2 from "SharingApp/ts/services/sharing.service";
import * as i3 from "@ngrx/store";
import * as i4 from "NewAngular/features/components/toast-messages/toast-messages.service";
import * as i5 from "FoldersApp/services/selected-folderable.service";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i8 from "FoldersApp/features/folders-shared/folderable/folderable.directive";
import * as i9 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i10 from "FoldersApp/features/folders-shared/folder-operations-dropdown/folder-operations-dropdown.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i12 from "NewAngular/features/components/saved-items/open-item-modal/components/open-item-preview-modal/open-item-preview-modal.component";
import * as i13 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i14 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i15 from "../../../../../../../../sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = ["previewModal"];
function FundChartFolderableItemComponent_Conditional_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "div", 9);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 10);
    i0.ɵɵelement(4, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 11)(6, "div", 12);
    i0.ɵɵelement(7, "ycn-folder-operations-dropdown", 13);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folder_r1 = ctx.folder;
    i0.ɵɵnextContext();
    const folderBase_r2 = i0.ɵɵreference(1);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(2, 9, folder_r1.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.ownerName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", ctx_r2.relativePositionedElemId)("item", folder_r1)("folderIsDisabled", folderBase_r2.itemSelectionDisabled)("listItemView", true)("resourceType", ctx_r2.folderable.resourceType)("resourceTypeDescription", ctx_r2.folderable.resourceTypeDescription)("ancestorFolderId", ctx_r2.ancestorInfo.id);
} }
function FundChartFolderableItemComponent_Conditional_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-fund-chart-folderable-item", 14);
} if (rf & 2) {
    const folderable_r4 = ctx.folderable;
    const ancestorInfo_r5 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r4)("ancestorInfo", ancestorInfo_r5);
} }
function FundChartFolderableItemComponent_Conditional_0_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span");
    i0.ɵɵtext(2, "There are no fundamental charts in this folder.");
    i0.ɵɵelementEnd()();
} }
function FundChartFolderableItemComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-base", 7, 1);
    i0.ɵɵtemplate(2, FundChartFolderableItemComponent_Conditional_0_ng_template_2_Template, 8, 12, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, FundChartFolderableItemComponent_Conditional_0_ng_template_4_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(6, FundChartFolderableItemComponent_Conditional_0_ng_template_6_Template, 3, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const folderColumnDataFragment_r6 = i0.ɵɵreference(3);
    const listItemFragment_r7 = i0.ɵɵreference(5);
    const emptyFolderFragment_r8 = i0.ɵɵreference(7);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r6)("listItemFragment", listItemFragment_r7)("emptyFolderFragment", emptyFolderFragment_r8);
} }
function FundChartFolderableItemComponent_Conditional_1_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", ctx_r2.sharingTooltipMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function FundChartFolderableItemComponent_Conditional_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18)(2, "label", 19)(3, "input", 20);
    i0.ɵɵlistener("click", function FundChartFolderableItemComponent_Conditional_1_div_0_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.bulkActionSelectionService.toggleSelectedItem(ctx_r2.folderable.resourceType, ctx_r2.fundChart.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 21);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 22)(6, "div", 23)(7, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 25);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 26);
    i0.ɵɵtext(10, "fc");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "a", 27);
    i0.ɵɵlistener("click", function FundChartFolderableItemComponent_Conditional_1_div_0_Template_a_click_11_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.selectedFolderableService.selectFolderable(ctx_r2.fundChart.id)); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, FundChartFolderableItemComponent_Conditional_1_div_0_div_12_Template, 2, 4, "div", 28);
    i0.ɵɵpipe(13, "isSharedWithOthers");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 8);
    i0.ɵɵelement(15, "div", 9);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 10);
    i0.ɵɵelement(18, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 11)(20, "div", 12)(21, "ycn-simple-dropdown", 29);
    i0.ɵɵlistener("handler", function FundChartFolderableItemComponent_Conditional_1_div_0_Template_ycn_simple_dropdown_handler_21_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.fileDropdownHandler($event)); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("bg-yc-blue-90", ctx_r2.checked);
    i0.ɵɵproperty("folderable", ctx_r2.folderable)("ancestorInfo", ctx_r2.ancestorInfo);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r2.itemSelectionDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r2.checked);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", "icon-file");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.fundChart.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 19, ctx_r2.fundChart));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", i0.ɵɵpipeBind2(16, 21, ctx_r2.fundChart.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r2.ownerName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("id", ctx_r2.relativePositionedElemId)("inputDisabled", ctx_r2.itemSelectionDisabled)("tooltipTitle", "More Options")("tooltipPlacement", "bottom")("buttonClass", "btn btn-secondary arrow-down")("config", ctx_r2.fileDropdownConfig)("dropdownClass", "dropdown-menu-right dropdown-menu-with-icons")("showDropdownCaret", false);
} }
function FundChartFolderableItemComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, FundChartFolderableItemComponent_Conditional_1_div_0_Template, 22, 24, "div", 16);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r2.bulkActionSelectionService.items$));
} }
// Constants
export class FundChartFolderableItemComponent extends FolderableBase {
    constructor(folderableAjaxService, sharingService, store, toastMessagesService, selectedFolderableService) {
        super();
        this.folderableAjaxService = folderableAjaxService;
        this.sharingService = sharingService;
        this.store = store;
        this.toastMessagesService = toastMessagesService;
        this.selectedFolderableService = selectedFolderableService;
        this.SavedItemType = SavedItemType;
        this.sharingTooltipMessage = '';
    }
    get fileDropdownConfig() {
        const shareOption = {
            type: 'option',
            label: 'Share',
            value: ChartDropdownOption.SHARE,
            icon: 'icon-share',
            disabled: !this.fundChart.permissions.canShare,
        };
        const { label, disabled } = getSharingButtonConfig(shareOption, this.fundChart, this.fundChart.permissions.canShare);
        shareOption.label = label;
        shareOption.disabled = disabled;
        return {
            title: {
                label: '',
                icon: 'icon-dots-more',
            },
            list: [
                {
                    type: 'option',
                    label: 'Preview',
                    value: ChartDropdownOption.PREVIEW,
                    icon: 'icon-password-show',
                    disabled: !this.fundChart.permissions.canView,
                },
                shareOption,
                {
                    type: 'option',
                    label: 'Rename',
                    value: ChartDropdownOption.RENAME,
                    icon: 'icon-edit',
                    disabled: !this.fundChart.permissions.canRename,
                },
                {
                    type: 'option',
                    label: 'Move',
                    value: ChartDropdownOption.MOVE,
                    icon: 'icon-folder-move',
                    disabled: !this.fundChart.permissions.canMove,
                },
                {
                    type: 'option',
                    label: 'Delete',
                    value: ChartDropdownOption.DELETE,
                    icon: 'icon-delete',
                    disabled: !this.fundChart.permissions.canDelete,
                },
            ],
        };
    }
    get fundChart() {
        return this.folderable.item;
    }
    ngOnInit() {
        this.sharingTooltipMessage = this.sharingService.getSharingTooltipMessage(this.folderable.item);
    }
    fileDropdownHandler(operationName) {
        switch (operationName) {
            case ChartDropdownOption.PREVIEW:
                this.preview();
                break;
            case ChartDropdownOption.SHARE:
            case ChartDropdownOption.RENAME:
            case ChartDropdownOption.MOVE:
            case ChartDropdownOption.DELETE:
                const selectedFolderableItem = {
                    id: this.fundChart.id,
                    name: this.fundChart.name,
                    // The name of the backend Model
                    itemType: this.folderable.resourceType,
                    // A human-readable description of the item type
                    itemTypeDescription: this.folderable.resourceTypeDescription,
                    ancestorFolderId: this.ancestorInfo.id,
                    sharing: this.fundChart.sharing,
                    relativePositionedElemId: this.relativePositionedElemId,
                };
                this.store.dispatch(setSelectedFolderableOperation({
                    selectedOperation: {
                        item: selectedFolderableItem,
                        operation: operationName,
                    },
                }));
                break;
            default:
                throw new Error(`Unknown operation ${operationName}`);
        }
    }
    preview() {
        this.previewModal.modalOpen = true;
        this.folderableAjaxService.getFolderableItem(FolderableType.FUND_CHART, this.folderable.item.id).subscribe({
            next: (response) => {
                const { item } = response;
                const formattedItem = {
                    ...response.item,
                    // Store the modify_date as a date object so it can be used for sorting
                    modifyDateObj: new Date(item.modify_date),
                    tooltipMessage: item.sharing ? this.sharingService.getSharingTooltipMessage(item) : '',
                };
                this.previewModal.openModal(formattedItem);
            },
            error: () => {
                this.previewModal.loading = false;
                this.previewModal.closeModal();
                this.toastMessagesService.addMessage('There was an error loading the preview image.', ToastMessageType.ERROR);
            },
        });
    }
}
FundChartFolderableItemComponent.ɵfac = function FundChartFolderableItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartFolderableItemComponent)(i0.ɵɵdirectiveInject(i1.FolderableAjaxService), i0.ɵɵdirectiveInject(i2.SharingService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.ToastMessagesService), i0.ɵɵdirectiveInject(i5.SelectedFolderableService)); };
FundChartFolderableItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartFolderableItemComponent, selectors: [["ycn-fund-chart-folderable-item"]], viewQuery: function FundChartFolderableItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewModal = _t.first);
    } }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [["previewModal", ""], ["folderBase", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], ["ycn-folderable", "", 1, "tr", 3, "bg-yc-blue-90", "folderable", "ancestorInfo"], [3, "savedItemType"], [3, "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment"], [1, "td", "col-3"], [1, "file-td-wrap", 3, "textContent"], [1, "td", "col-3", "col-md-2"], [1, "td", "file-td-grip", "col-3", "col-lg-1"], [1, "btn-group"], [3, "id", "item", "folderIsDisabled", "listItemView", "resourceType", "resourceTypeDescription", "ancestorFolderId"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"], ["class", "tr", "ycn-folderable", "", 3, "bg-yc-blue-90", "folderable", "ancestorInfo", 4, "ngIf"], ["ycn-folderable", "", 1, "tr", 3, "folderable", "ancestorInfo"], [1, "td-checkbox"], ["ycnDisabled", "", 1, "custom-control", "custom-checkbox", 3, "disabled"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "td", "file-td-name"], [1, "file-name", "file-td-wrap"], [1, "file-icon", "file-fc"], ["ycnIcon", "", 3, "name"], [1, "file-abbr"], ["href", "javascript:void(0)", 3, "click", "textContent"], ["class", "btn btn-xs btn-circle btn-transparent btn-share ml-1", "ycnTooltip", "", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], ["ycnTooltip", "", 1, "dropdown", 3, "handler", "id", "inputDisabled", "tooltipTitle", "tooltipPlacement", "buttonClass", "config", "dropdownClass", "showDropdownCaret"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-share", "ml-1", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"]], template: function FundChartFolderableItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, FundChartFolderableItemComponent_Conditional_0_Template, 8, 5)(1, FundChartFolderableItemComponent_Conditional_1_Template, 2, 3, "div", 5);
        i0.ɵɵelement(2, "ycn-open-item-preview-modal", 6, 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.folderable.resourceType === "folder" ? 0 : 1);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("savedItemType", ctx.SavedItemType.FUND_CHART);
    } }, dependencies: [i6.NgIf, i7.DisabledDirective, i8.FolderableDirective, i9.FolderBaseComponent, i10.FolderOperationsDropdownComponent, i11.IconDirective, i12.OpenItemPreviewModalComponent, i13.SimpleDropdownComponent, i14.TooltipDirective, FundChartFolderableItemComponent, i6.AsyncPipe, i6.DatePipe, i15.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
